   <form  [formGroup]="formDialog"> 
  <h2 mat-dialog-title>
     <div class="title" *ngIf="addedFor=='Asset'">
      <mat-icon class="icon">account_balance</mat-icon>
       <span *ngIf="assetID==0" class="title-text">Add Asset - </span> <b *ngIf="assetID==0" style="color: #2e5bff;"> {{ selectedCoreName }}</b>
       <span *ngIf="assetID>0" class="title-text">Update Asset - </span> <b *ngIf="assetID>0" style="color: #2e5bff;"> {{ selectedCoreName }}</b>
       <!-- <span class="title-text">Add Asset - {{selectedCoreName}}</span> -->
    </div>
    <div class="title" *ngIf="addedFor=='Expense'">
      <mat-icon class="icon">attach_money</mat-icon>
      <span *ngIf="expenseID==0" class="title-text">Add Expense - </span> <b *ngIf="expenseID==0" style="color: #2e5bff;"> {{ selectedCoreName }}</b>
      <span *ngIf="expenseID>0" class="title-text">Update Expense - </span> <b *ngIf="expenseID>0" style="color: #2e5bff;"> {{ selectedCoreName }}</b>
      <!-- <span class="title-text">Add Expense - {{selectedCoreName}}</span> -->
    </div>

    <button mat-icon-button (click)="closeDialog()" >
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

  <mat-dialog-content>




  <div class="modal-body">

    <label class="form-label">Name of {{addedFor}}</label>
    <input matInput class="form-input" placeholder="e.g., Savings Account, Property" 
    formControlName="title">

    <label class="form-label">Amount</label>
    <div class="input-with-icon">
      <span class="icon">$</span>
      <input matInput class="form-input no-left-radius" placeholder="0.00" (keypress)="numberOnly($event)" 
      formControlName="amount">
    </div>

    <label class="form-label">Note</label>
    <textarea matInput class="form-textarea" placeholder="Add any relevant notes about this {{addedFor}}..."
     formControlName="description"></textarea>

    <label class="form-label">Classification</label>
    <mat-radio-group formControlName="classification" class="primary">
    <mat-radio-button value="1">Countable</mat-radio-button> &nbsp;&nbsp;
    <mat-radio-button value="0">Excluded</mat-radio-button>
    </mat-radio-group>

    <label class="form-label">Type</label>
    <mat-radio-group formControlName="type" class="primary">
    <mat-radio-button value="0">Resident</mat-radio-button> &nbsp;&nbsp;
    <mat-radio-button value="1">Spouse</mat-radio-button>
    </mat-radio-group>

    <!-- <div class="radio-group">
      <label class="radio-option">
        <input type="radio" name="classification" checked>
        <span>Countable</span>
      </label>

      <label class="radio-option">
        <input type="radio" name="classification">
        <span>Excluded</span>
      </label>
    </div> -->
  </div>

  <div class="modal-footer">
     <button mat-button (click)="closeDialog()" class="cancel-btn">Cancel</button>
    
     <button mat-flat-button color="primary" *ngIf="addedFor=='Asset' && assetID==0" mat-flat-button color="primary"  [disabled]="formDialog.invalid || !formDialog.dirty"
     (click)="addAsset(formDialog.value)">Save
     </button>
     <button mat-flat-button color="primary" *ngIf="addedFor=='Asset' && assetID>0" mat-flat-button color="primary"  [disabled]="formDialog.invalid || !formDialog.dirty"
      (click)="addAsset(formDialog.value)">Update
      </button>

     <button mat-flat-button color="primary" *ngIf="addedFor=='Expense' && expenseID==0"  mat-flat-button color="primary"  [disabled]="formDialog.invalid || !formDialog.dirty"
      (click)="addExpense(formDialog.value)">Save
      </button>
     <button mat-flat-button color="primary" *ngIf="addedFor=='Expense' && expenseID>0"  mat-flat-button color="primary"  [disabled]="formDialog.invalid || !formDialog.dirty"
      (click)="addExpense(formDialog.value)">Update
     </button>

  </div>
 
  </mat-dialog-content>
  </form>
  




  

  




